import { WarningSchema } from "@/schemas/warning-data-schema";

export const getHighestWarningForTodayAndTomorrow = (
	warnings: WarningSchema[],
): { today: number; tomorrow: number } => {
	const today = new Date();
	const tomorrow = new Date();

	tomorrow.setDate(today.getDate() + 1);

	const isSameDay = (timestamp: string, date: Date) => {
		const warningDate = new Date(timestamp);

		return (
			warningDate.getUTCFullYear() === date.getUTCFullYear() &&
			warningDate.getUTCMonth() === date.getUTCMonth() &&
			warningDate.getUTCDate() === date.getUTCDate()
		);
	};

	const todayWarnings = warnings.filter((warning) =>
		isSameDay(warning.properties.effective_str, today),
	);

	const tomorrowWarnings = warnings.filter((warning) =>
		isSameDay(warning.properties.effective_str, tomorrow),
	);

	return {
		today: Math.max(...todayWarnings.map((w) => w.properties.value), 1),
		tomorrow: Math.max(...tomorrowWarnings.map((w) => w.properties.value), 1),
	};
};
